const SET_COUPON_STATUS = 'viewDesigns/upgrade/SET_COUPON_STATUS';

export default function reducer(state = {}, action = {}) {
  switch (action.type) {
    case SET_COUPON_STATUS:
      return {
        ...state,
        couponStatus: action.couponStatus
      };
    default:
      return state;
  }
}

export function setCouponStatus(couponStatus) {
  return {type: SET_COUPON_STATUS, couponStatus};
}
